import React from "react";
import {
  Box,
  Flex,
  Heading,
  Text,
  Button,
  Stack,
  SimpleGrid,
  Image,
  HStack,
  VStack,
  Link,
} from "@chakra-ui/react";
import { Link as RouterLink2 } from "react-router-dom";
import { NavLink as RouterLink } from "react-router-dom";
import { motion } from "framer-motion";
import homehero from "../assets/homehero.jpg";
import WorldMap from "../components/WorldMap";
import designEngg from "../assets/designengg.jpg";
import consultingBg from "../assets/ccs.jpg";
import pmcBg from "../assets/pmcbg.jpg";
import epcImg from "../assets/epcmgmg.jpg";
import feasibilityBg from "../assets/feasibility.jpg"; // Add hero background image
import supplychain from "../assets/supplychain.jpg";
import solar24 from "../assets/savemoney.jpg";
import savemoney from "../assets/solar24-7.jpg";
import relibility from "../assets/relibility.jpg";
import home1 from "../assets/home1.jpg";
import home2 from "../assets/home2.jpg";
import home3 from "../assets/home3.jpg";
import horisondeliver from "../assets/horisondeliver.jpg";

export default function Home() {
  const MotionBox = motion(Box);
  const MotionButton = motion(Button);
  const MotionFlex = motion(Flex);
  const MotionText = motion(Text);

  const services = [
    {
      title: "Design & Engineering",
      desc: "Cutting-edge solar designs for maximum efficiency.",
      img: designEngg,
      path: "/services/design",
    },
    {
      title: "Supply Chain Management",
      desc: "Streamlined logistics for timely delivery.",
      img: supplychain,
      path: "/services/supply-chain",
    },
    {
      title: "EPC Management (EPCM)",
      desc: "End-to-end management of Engineering, Procurement & Construction.",
      img: epcImg,
      path: "/services/epc-management",
    },
    {
      title: "MW-Scale Project Management Consultancy",
      desc: "Comprehensive consultancy for utility-scale solar projects.",
      img: consultingBg,
      path: "/services/consultancy",
    },
    {
      title: "Feasibility Study",
      desc: "Analysis of viability, energy yield, and ROI.",
      img: feasibilityBg,
      path: "/services/feasibility-study",
    },
    {
      title: "Consulting & Compliance Services",
      desc: "Expert advice and compliance support for regulations.",
      img: pmcBg,
      path: "/services/advisory",
    },
  ];

  const whyHorisun = [
    {
      title: "Service with Vision",
      desc: "We work closely with our clients to ensure every project excels in execution, durability, and operational efficiency — delivering long-term value and maximum return on investment.",
      img: solar24,
    },
    {
      title: "Cost-Optimized, Quality-Driven",
      desc: "We design efficient, cost-effective systems that lower project expenses and boost ROI — without compromising on performance or durability.",
      img: savemoney,
    },
    {
      title: "Highly Skilled Team",
      desc: "Our dynamic team of experienced and driven professionals brings fresh energy and deep expertise to every project — consistently delivering innovative, high-quality solutions.",
      img: relibility,
    },
    {
      title: "Advanced Engineering Excellence",
      desc: "Utilizing the newest technology and intelligent software, we provide optimized, error-free engineering tailored for maximum efficiency",
      img: horisondeliver,
    },
  ];

  return (
    <Box bg="#F5FAF6" minH="100vh">
      {/* Hero Section */}
      <Flex
        direction="column"
        align="center"
        justify="center"
        bgImage={`url(${homehero})`}
        bgSize="cover"
        bgPosition="center"
        bgRepeat="no-repeat"
        minH={{ base: "70vh", md: "70vh" }} // 🔹 reduced height
        position="relative"
        w="100%"
        mx="auto"
        overflow="hidden"
      >
        {/* Dark Overlay */}
        <Box
          position="absolute"
          top={0}
          left={0}
          w="100%"
          h="100%"
          bg="rgba(0,0,0,0.45)"
          zIndex={0}
        />

        {/* Centered Heading */}
        <Stack
          spacing={{ base: 4, md: 6 }}
          maxW={{ base: "95%", md: "100%" }}
          textAlign="center"
          position="relative"
          zIndex={1}
          as={motion.div}
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ type: "spring", stiffness: 80, damping: 15 }}
        >
          {/* Animated Heading */}
          <Heading
            fontSize={{ base: "lg", md: "5xl" }}
            maxW="100%"
            mx="auto"
            textAlign="center"
            color="white"
            textShadow="2px 2px 8px rgba(0,0,0,0.6)"
            fontWeight="bold"
            lineHeight="shorter"
          >
            {"Driven by Global Expertise".split(" ").map((word, index) => (
              <motion.span
                key={index}
                style={{ display: "inline-block", marginRight: "8px" }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.25, duration: 0.6 }}
                // slower word flow
              >
                {word}
              </motion.span>
            ))}
            <br />
            {"Delivering Future-Ready Energy Solutions"
              .split(" ")
              .map((word, index) => (
                <motion.span
                  key={`line2-${index}`}
                  style={{ display: "inline-block", marginRight: "8px" }}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: (index + 6) * 0.25, duration: 0.6 }}
                  // continue stagger for second line
                >
                  {word}
                </motion.span>
              ))}
          </Heading>

          {/* Animated Button */}
          <RouterLink to="/contact">
            <MotionButton
              bg="#F6A11A"
              color="white"
              size="lg"
              w={{ base: "100%", md: "250px" }}
              whileHover={{
                scale: 1.08,
                boxShadow: "0px 0px 15px #F6A11A",
                backgroundColor: "#e59415",
              }}
              as={motion.button}
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 3.5, type: "spring", stiffness: 80 }}
              fontWeight="bold"
              fontSize="lg"
              textShadow="1px 1px 2px rgba(0,0,0,0.3)"
            >
              Get Started
            </MotionButton>
          </RouterLink>
        </Stack>
      </Flex>

      {/* Subtext Section Below Hero */}

      <MotionFlex
        direction={{ base: "column", md: "row" }}
        align="center"
        justify="center"
        w="100%"
        maxW="100%"
        mx="auto"
        overflow="hidden"
        bgColor="#F5FAF6"
        py={{ base: 10, md: 10 }}
        initial={{ opacity: 0, y: 40, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        {/* Left Text Section */}
        <MotionFlex
          w={{ base: "100%", md: "100%" }}
          direction="column"
          align={{ base: "center", md: "flex-start" }}
          justify="center"
          px={{ base: 0, md: 8 }}
          py={{ base: 10, md: 0 }}
          initial="hidden"
          animate="visible"
          variants={{
            visible: { transition: { staggerChildren: 0.07 } },
          }}
        >
          <Box
            w="100%"
            bgColor="#F5F5F5"
            p={{ base: 6, md: 16 }}
            borderRadius={{ base: "none", md: "3xl" }}
            boxShadow="2xl"
          >
            <Heading mb={4} color={"black"}>
              Your Trusted Partner For All-in-one Renewable Energy Solutions
            </Heading>

            <Box mb={6}>
              {`HoriSun is a one-stop platform providing turnkey solutions to Solar Developers, EPCs & Installers. Founded in 2022 as an engineering company, we have broadened our services to include SCM, EPCM, and PMC. Our services are available at any project stage: from Pre-Sale & early planning to construction, installation, and commissioning.`
                .split(" ")
                .map((word, index) => (
                  <MotionText
                    key={index}
                    as="span"
                    fontSize={{ base: "s", md: "lg" }}
                    lineHeight="shorter"
                    color="#305D24"
                    fontWeight="semibold"
                    fontFamily="'Poppins', sans-serif"
                    textAlign={{ base: "center", md: "left" }}
                    letterSpacing="wider"
                    display="inline-block"
                    mr={2}
                    variants={{
                      hidden: { opacity: 0, y: 20, scale: 0.9 },
                      visible: {
                        opacity: 1,
                        y: 0,
                        scale: 1,
                        transition: { duration: 0.5, ease: "easeOut" },
                      },
                    }}
                  >
                    {word}
                  </MotionText>
                ))}
            </Box>

            {/* Learn More Button */}
            <RouterLink to="/about#why">
              <Button
                bg="#F6A11A"
                color="white"
                size="lg"
                fontWeight="bold"
                _hover={{ bg: "#e59415", boxShadow: "0px 0px 10px #F6A11A" }}
              >
                Learn More
              </Button>
            </RouterLink>
          </Box>
        </MotionFlex>

        {/* Right Images Section */}
        <Flex
          w="100%"
          direction={{ base: "column", md: "row" }}
          align="center"
          justify="center"
          gap={4}
          mt={{ base: 10, md: 0 }}
          mr={{ base: 10, md: 5 }}
        >
          {/* Left Column (2 stacked images) */}
          <VStack spacing={4} w={{ base: "100%", md: "50%" }}>
            <Image
              src={home1}
              alt="Image 1"
              objectFit="cover"
              w="100%"
              h="200px"
              borderRadius="xl"
              boxShadow="lg"
            />
            <Image
              src={home2}
              alt="Image 2"
              objectFit="cover"
              w="100%"
              h="200px"
              borderRadius="xl"
              boxShadow="lg"
            />
          </VStack>

          {/* Right Column (1 vertical image matching height of left column) */}
          <Box
            w={{ base: "100%", md: "50%" }}
            h={{ base: "auto", md: "416px" }}
          >
            <Image
              src={home3}
              alt="Image 3"
              objectFit="cover"
              w="100%"
              h={{ base: "auto", md: "100%" }} // using auto height on base for proportional scaling
              borderRadius="xl"
              boxShadow="lg"
            />
          </Box>
        </Flex>
      </MotionFlex>

      <br></br>

      <Box py={10} bg="#F5FAF6">
        <Heading
          textAlign="center"
          mb={12}
          color="#519C36"
          fontSize={{ base: "2xl", md: "5xl" }}
        >
          Why HoriSun
        </Heading>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
          {whyHorisun.map((item, index) => (
            <MotionBox
              key={item.title}
              position="relative"
              rounded="2xl"
              p={6}
              shadow="xl"
              border="1px solid #E6F3EA"
              overflow="hidden"
              whileHover={{
                scale: 1.05,
                y: -5,
                boxShadow: "0px 12px 30px rgba(0,0,0,0.1)",
                borderColor: "#F6A11A",
              }}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, type: "spring", stiffness: 80 }}
              minH="280px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {/* Background image with blur */}
              <Image
                src={item.img}
                alt={item.title}
                objectFit="cover"
                position="absolute"
                top={0}
                left={0}
                w="100%"
                h="100%"
                zIndex={0}
                filter="brightness(0.6) blur(2px)" // subtle blur
              />

              {/* Content overlay */}
              <VStack
                spacing={4}
                align="center"
                textAlign="center"
                p={6}
                rounded="xl"
                zIndex={1} // ensures text stays above blurred bg
              >
                <Heading
                  fontSize={{ base: "md", md: "lg" }}
                  color="white"
                  textTransform="none"
                  letterSpacing="wide"
                >
                  {item.title}
                </Heading>
                <Text
                  fontSize={{ base: "sm", md: "md" }}
                  color="white"
                  fontWeight="bold"
                >
                  {item.desc}
                </Text>
              </VStack>
            </MotionBox>
          ))}
        </SimpleGrid>
      </Box>

      {/* Services */}
      <Box mb={12}>
        <Heading
          mb={8}
          fontSize={{ base: "2xl", md: "5xl" }}
          color="#519C36"
          textAlign="center"
        >
          Our Services
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
          {services.map((service, index) => (
            <Link
              as={RouterLink2}
              to={service.path}
              key={service.title}
              _hover={{ textDecoration: "none" }}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} // scroll to top
            >
              <MotionBox
                bg="#FFFFFF"
                rounded="2xl"
                shadow="2xl"
                overflow="hidden"
                border="2px solid #F5FAF6"
                cursor="pointer"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  delay: index * 0.1,
                  type: "spring",
                  stiffness: 90,
                }}
                whileHover={{
                  scale: 1.05,
                  rotate: 1,
                  boxShadow: "0px 15px 25px rgba(0,0,0,0.2)",
                  borderColor: "#F6A11A",
                }}
              >
                <Image
                  src={service.img}
                  alt={service.title}
                  objectFit="cover"
                  w="100%"
                  h="200px"
                />
                <Box p={6}>
                  <Heading fontSize="xl" mb={3} color="#305D24">
                    {service.title}
                  </Heading>
                  <Text color="#519C36">{service.desc}</Text>
                </Box>
              </MotionBox>
            </Link>
          ))}
        </SimpleGrid>
      </Box>

      {/* Projects Section */}
      <Box mb={12}>
        <WorldMap />
        <Flex justify="center" py={10}>
          <Button
            bg="#FBBF24"
            color="#065F46"
            size="lg"
            as="a"
            href="/contact"
            _hover={{ bg: "#F59E0B" }}
          >
            Get in Touch
          </Button>
        </Flex>
      </Box>
    </Box>
  );
}
